import { Eye } from 'lucide-react'
import { formatDate } from '../../services/statisticsService'
import { getTypeLabel } from '../../services/statisticsService'

export const StatCard = ({
  id,
  title,
  views,
  icon,
  createdAt,
  type,
}: {
  id: number
  title: string
  views: number
  icon: JSX.Element
  createdAt: string
  type: string
}) => {
  return (
    <div className='bg-white rounded-lg shadow-lg p-4 border border-gray-100 hover:shadow-xl transition-all duration-300'>
      <div className='flex items-center gap-3 mb-3'>
        <div className='p-2 rounded-lg bg-opacity-10 bg-redpink'>{icon}</div>
        <div className='flex-1'>
          <span className='text-xs text-anthracite px-2 py-1 bg-grisclair rounded-md inline-block mb-1'>
            {getTypeLabel(type)}
          </span>
          <span className='text-xs text-gray-500 block'>
            {formatDate(createdAt)}
          </span>
        </div>
      </div>

      <div className='flex items-center justify-between'>
        <h3
          className='font-medium text-anthracite text-sm truncate flex-1 pr-4'
          title={title}
        >
          {title}
        </h3>
        <div className='flex items-center gap-1 whitespace-nowrap'>
          <Eye className='w-4 h-4 text-gray-400' />
          <span className='text-lg font-bold text-anthracite'>
            {views?.toLocaleString() || 0}
          </span>
        </div>
      </div>
    </div>
  )
}
